import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const VideoIcon = ({ color = '#B5BCBD', size = '16', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.678 6H2.656C1.189 6 0 7.17 0 8.614v15.772C0 25.83 1.189 27 2.656 27h16.022c1.466 0 2.655-1.17 2.655-2.614V8.614C21.333 7.17 20.144 6 18.678 6zM29.2 8.062l-6.089 4.134v8.608l6.089 4.129c1.178.798 2.8-.017 2.8-1.411V9.472c0-1.388-1.617-2.209-2.8-1.41z"
      fill={color}
    />
  </svg>
);

VideoIcon.propTypes = propTypes;

export default VideoIcon;
